// Which API this form talks to.
//
// PRODUCTION IS api.waivers.tattoo — since CUTOVER Phase 4 (2026-09-07 15:23Z) every subdomain, the six
// original shops included, serves the bundle on the wildcard CDN, and that bundle calls the API in the
// product's own account. `./run.sh deploy-form` still passes REACT_APP_API_URL explicitly and refuses a
// bundle that carries the legacy execute-api URL (docs/CUTOVER.md); this default is what a bare
// `npm run build` produces, so it names the live API and nothing else. The legacy API in account 657
// is a warm standby until Phase 5 and is deliberately not written here, even as a fallback.
const DEPLOYED_API_URL = "https://api.waivers.tattoo/form/api/v1";

const LOCAL_API_URL = "http://localhost:3100/form/api/v1";

// REACT_APP_API_URL beats both, at BUILD time (Create React App inlines it). That is how the dev
// stack and the cutover's canary subdomain are pointed somewhere else without a code change.
const isDevServer = process.env.NODE_ENV === "development";

export const API_URL =
  process.env.REACT_APP_API_URL || (isDevServer ? LOCAL_API_URL : DEPLOYED_API_URL);

// THE PROMOTIONS SERVICE (services/promotions, Elixir), which the paused screen asks for a top-up (TW-0286): the one door
// of it this form calls, public, CORS for every shop's own subdomain and the dev server on :3002. Locally the service runs
// on :4100 (`./run.sh promotions-dev`), with no data key, so the door answers "could not ask" and the screen offers
// nothing. REACT_APP_PROMOTIONS_URL beats both, at build time, like the API's.
const DEPLOYED_PROMOTIONS_URL = "https://promotions.waivers.tattoo";
const LOCAL_PROMOTIONS_URL = "http://localhost:4100";

export const PROMOTIONS_URL =
  process.env.REACT_APP_PROMOTIONS_URL || (isDevServer ? LOCAL_PROMOTIONS_URL : DEPLOYED_PROMOTIONS_URL);

// THE TWO LEGAL URLS THE A2P CAMPAIGN FILING NAMES, AND THE ONE PLACE THEY ARE WRITTEN (TW-0111).
// `PrivacyPolicyUrl` and `TermsAndConditionsUrl` on the campaign point at exactly these, so what a
// carrier reviewer clicks from the consent boxes is what the filing claims. They are absolute on
// purpose: this bundle is served from every shop's own subdomain, and a relative /privacy there
// resolves to the shop's form, not to the site. Change one and change the campaign with it —
// infrastructure/twilio/register-campaign.py, and `./run.sh texting --preflight` fails on drift.
export const SITE_PRIVACY_URL = "https://www.waivers.tattoo/privacy";
export const SITE_TERMS_URL = "https://www.waivers.tattoo/terms";

// THE COMPANY BEHIND waivers.tattoo, the consent page's second party (TW-0249, 2026-10-16), as the root entity.json names it
// and as the terms and the privacy policy name it ("Tattoo Waivers LLC, a Texas company"). Written here, beside the two legal
// URLs, because this bundle reads nothing outside src/ and the fact is one name; TermsAndConditions.test.tsx holds all three
// to entity.json, so the file and the page can never disagree (the deposit page's shape: apps/deposit-page/src/copy.test.ts).
// Not a copy of entity.json: that file's notes, its history and the filing's story would ship to every client's phone.
export const LEGAL_ENTITY = "Tattoo Waivers LLC";
export const LEGAL_ENTITY_PHRASE = "a Texas company";
/** the phrase in the Spanish page, entity.json's state in Spanish's own order (awaiting a native read) */
export const LEGAL_ENTITY_PHRASE_ES = "una empresa de Texas";
